export interface InitialNoticeDocument {
  id: number;
  initial_notice_id: number;
  document_name: string;
  path: string | null;
  extension: string | null;
}

// Single object mapping
export const mapInitialNoticeDocument = (data: any): InitialNoticeDocument => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const response: InitialNoticeDocument = {
    id: data?.id,
    initial_notice_id: data?.initial_notice_id,
    document_name: data?.document_name,
    path: data?.path,
    extension: data?.extension,
  };

  return response;
};

// List mapping
export const mapInitialNoticeDocuments = (
  data: any[]
): InitialNoticeDocument[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapInitialNoticeDocument);
};

export interface InitialNotice {
  id: number;
  project_id: number;
  folder_id: number;
  date: string | null;
  status: "Pending" | "Accepted" | "Not Accepted" | null;
  is_published: 1 | 0;
  initial_notice_document: InitialNoticeDocument[];
}

// Single object mapping
export const mapInitialNotice = (data: any): InitialNotice => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const response: InitialNotice = {
    id: data?.id,
    project_id: data?.project_id,
    folder_id: data?.folder_id,
    date: data?.date || null,
    status: data?.status || null,
    is_published: data?.is_published,
    initial_notice_document: Array.isArray(data?.initial_notice_document)
      ? mapInitialNoticeDocuments(data?.initial_notice_document)
      : [],
  };

  return response;
};

// List mapping
export const mapInitialNotices = (data: any[]): InitialNotice[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapInitialNotice);
};
